<template>
  <div class='cm-company-card__container' :class='{
    mini
  }'>
    <!-- <Heart
      v-if="isLoggedIn && !mini"
      class="cm-company-card__like"
      :company="company"
      @like='$emit("like", company.id)'
      @unlike='$emit("unlike", company.id)'
    /> -->
    <a class='cm-company-card cm-card raised' :class='{
    mini
  }' :href="company.url">
      <div v-if="company.is_hiring" class="cm-company-card__hiring">
        {{ translate('hiring') }}
      </div>
      <div v-if="!mini" class="cm-company-card__banner">
        <img :src="company.banner || '/companies/' + company.id + '/banner'" :alt="`${company.name} banner`"
          loading="lazy">
      </div>
      <div class="cm-company-card__info">
        <aside class="cm-company-card__logo">
          <img :src="company.logo" :alt="`${company.name} logo`" loading="lazy">
        </aside>
        <section class="cm-company-card__name">
          <h3>{{ company.name }}</h3>
          <p v-if="location" class="cm-company-card__location">{{ location }}</p>
          <p class="cm-company-card__motto">{{ company.motto }}</p>
        </section>
      </div>
    </a>
  </div>
</template>

<script>
import Heart from "../company/heart";
import translationMixin from "../mixins/translation";

export default {
  components: {
    Heart
  },

  mixins: [translationMixin],

  props: {
    company: {
      type: Object
    },
    liked: {
      type: Boolean
    },
    isLoggedIn: {
      type: Boolean
    },
    mini: {
      type: Boolean
    }
  },

  computed: {
    location() {
      const locations = this.company.locations
      return locations && locations.length && locations[0].address
    }
  }
};
</script>

<style lang='scss' scoped>
.cm-company-card {
  position: relative;
  display: block;
  height: 100%;
  @extend %b2;
  overflow: hidden;
  z-index: 1;

  &__container {
    position: relative;
    width: 100%;
  }

  a {
    font-weight: normal;
    text-decoration: none;
  }

  p {
    margin-bottom: 0 !important;
  }

  &__banner {
    height: 6rem;
    position: relative;
    overflow: hidden;
    background-color: var(--bg-2);

    img {
      min-height: 100%;
      -o-object-fit: cover;
      object-fit: cover;
      position: absolute;
      margin: auto;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
    }
  }

  &__hiring {
    font-size: 14px;
    font-weight: bold;
    position: absolute;
    top: 0;
    right: 0;
    background: var(--fg);
    color: var(--bg);
    padding: 0.15rem .5rem;
    border-bottom-left-radius: 5px;
    text-transform: uppercase;
  }

  &__like {
    position: absolute;
    top: 5px;
    right: 0.5rem;
  }

  &__info {
    @include clearfix;

    position: relative;
    display: flex;
    padding: 1.5rem 1rem 1.5rem 1.5rem;
  }

  &__logo {
    flex: 0 0 auto;
    border-radius: $radius;
    margin-right: 1rem;
    height: rem(64, 16);
    width: rem(64, 16);
    box-shadow: $box_shadow_20;
    overflow: hidden;

    @include min-width($bp_large) {
      height: 4.8rem;
      width: 4.8rem;
    }

    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }

  &__name {
    flex-grow: 1;
    margin-bottom: 0;
    overflow: hidden;

    &>h3 {
      @extend %h5;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  &__location {
    @include b3;
    margin-top: 0.1rem;
    color: var(--fg-2);
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    &::before {
      @include icon;
      content: 'location';
      font-size: 88.88%;
      margin-right: 0.2rem;
      transform: translateY(0.1rem);
    }
  }

  &__motto {
    text-overflow: ellipsis;
    word-wrap: break-word;
    @include line-clamp(2);
  }

  &__footer {
    @include clearfix;

    border-top: 1px solid var(--bg-2);
    color: var(--fg-2);
    font-size: $fs_small;
    font-weight: bold;
    padding: ($gutter / 2);

    nav {
      margin-top: $gutter * 2;
    }

    nav,
    footer {
      text-align: center;

      li {
        display: inline-block;

        &+li {
          margin-left: $gutter;
        }
      }

      a {
        border-width: 2px !important;
        font-size: $fs_large_body;
        margin-bottom: 25px;
        width: 100%;

        &:hover {
          padding: 7px 15px !important;
        }
      }
    }
  }
}

.social-fields {
  margin-bottom: $gutter;
}
</style>



// WEBPACK FOOTER //
// app/javascript/components/company-card.vue?7a307ac6